import { CardContent, ContentIsland, DateTime, Stack, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiDigitalWalletToken } from '../../../openapi';
import { useWalletName } from '../../DigitalWalletToken/useWalletName';

function Details({ label, value }: { label: React.ReactNode; value: React.ReactNode }) {
  return (
    <Stack spacing={2} justifyContent="space-between" width="100%">
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {value}
    </Stack>
  );
}

export function DigitalWalletTokenDetails({ token }: { token: ApiDigitalWalletToken }) {
  const { t } = useTranslation();
  const wallet = useWalletName(token);

  if (token.state === 'PROVISIONED' || token.state === 'TERMINATED') return null;

  return (
    <ContentIsland>
      <CardContent>
        <Stack spacing={2}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} width="100%">
            <Details
              label={t('Device')}
              value={<Typography>{token.deviceName || t('Unknown Device')}</Typography>}
            />
            <Details label={t('Time')} value={<DateTime value={token.tokenRequestedAt} />} />
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {t(
              'Your card will be added to {{wallet}} and will become available for use once you confirm this action. You can also choose to decline and not add the card.',
              { wallet },
            )}
          </Typography>
        </Stack>
      </CardContent>
    </ContentIsland>
  );
}
